import { useMutation, useQuery } from '@apollo/client';
import { Loading } from '@snapi/luxury';
import {
  GetMyDashboardQuery,
  CreateBabyQuery,
  UpdateBabyByIdQuery,
} from '@snapi/query';
import {
  Baby,
  CreateBaby,
  CreateBabyVariables,
  GetMyDashboard,
  GetMyDashboardVariables,
  UpdateBabyById,
  UpdateBabyByIdVariables,
} from '@snapi/types';
import { useAuth, useMyAppContext } from '@snapi/ui-utils';
import { differenceInMonths } from 'date-fns';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { DasbhoardPage } from '../../components/dashboard';

export default function NextDashboardPage() {
  const {
    state: { user },
  } = useAuth();
  const router = useRouter();
  const { state } = useAuth();

  const {
    state: { selected },
    setSelected,
  } = useMyAppContext();

  useEffect(() => {
    if (state.loaded && !state.authorized) {
      router.replace('/auth/register');
    }
  }, [state, router]);

  const { data, refetch, ...loadingDashboard } = useQuery<
    GetMyDashboard,
    GetMyDashboardVariables
  >(GetMyDashboardQuery, { variables: { parentId: user?.id } });

  const [updateBaby, updatingBaby] = useMutation<
    UpdateBabyById,
    UpdateBabyByIdVariables
  >(UpdateBabyByIdQuery);

  const [createBaby, creatingBaby] = useMutation<
    CreateBaby,
    CreateBabyVariables
  >(CreateBabyQuery);

  useEffect(() => {
    if (!selected && !loadingDashboard.loading) {
      const lastBorn = data?.babies?.[0];
      if (lastBorn) {
        setSelected(lastBorn);
      } else {
        router.push('/onboarding/1');
      }
    }
  }, [data, loadingDashboard]);

  useEffect(() => {
    const refetchInterval = setInterval(() => refetch(), 15000);
    return () => clearInterval(refetchInterval);
  }, [refetch]);

  const handleBabySave = async (baby: Baby) => {
    if (baby.id) {
      await updateBaby({
        variables: baby,
      });
    } else {
      await createBaby({
        variables: baby,
      });
    }
    await refetch();
  };

  const handleActivate = () => {
    if (selected) {
      const dob = new Date(selected.dob);
      const ageMonths = differenceInMonths(new Date(), dob);

      window.open(
        `https://rz1znu6024f.typeform.com/to/U0W4g5Yu#baby_name=${
          selected.name ?? 'Cutie'
        }&baby_age_months=${ageMonths}&baby_id=${selected.id}`,
        'popup'
      );
    }
  };

  if (
    loadingDashboard.loading ||
    updatingBaby.loading ||
    creatingBaby.loading ||
    !state.authorized
  ) {
    return <Loading />;
  }

  return (
    <DasbhoardPage
      babies={data?.babies ?? []}
      onActivate={handleActivate}
      onSave={handleBabySave}
    />
  );
}
